/**
 * @generated SignedSource<<8773e88a9b304076f28a2349a5f6e75f>>
 * @relayHash 79cec0a5552727ee3363f13bd6d502d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e24f3da21f5464146dca52ab8817081d4c4a4d45c82d4355e0be91668d34e1db

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e24f3da21f5464146dca52ab8817081d4c4a4d45c82d4355e0be91668d34e1db",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
